// React
import { ReactElement } from 'react';
import { Skeleton } from '../placeholder/Placeholder';
// Styles
import stylesNavigation from './navigation.module.scss';
import styles from './navigation-skeleton.module.scss';

interface NavigationSkeletonProps {
    isRegistrationPage?: boolean;
}

export const NavigationSkeleton = (props: NavigationSkeletonProps): ReactElement => {
    const { isRegistrationPage } = props;

    return (
        <ul className={stylesNavigation.list}>
            <li className={styles.skeleton}>&nbsp;</li>

            {[...new Array(isRegistrationPage ? 3 : 5)].map((v, i) => (
                <li key={i} className={styles.skeleton}>
                    <Skeleton className={styles.skeleton_icon} width="15%" height="30" />
                    <Skeleton className={styles.skeleton_brand} width="60%" height="30" />
                </li>
            ))}
        </ul>
    );
};
